{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Prepojiť na operátora",
    "MESSAGE": "Prepoj ma na operátora"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Stiahnuť",
      "UPLOADING": "Nahrávanie..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Odoslať"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Znova odoslať správu",
      "ERROR_MESSAGE": "Nepodarilo sa odoslať, skúste to znova"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Ohodnoťte kvalitu odpovede"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Počkajte, kým sa pripojí agent"
  },
  "ROBOT_CHECK": {
    "TITLE": "Rýchle bezpečnostné overenie",
    "DESCRIPTION": "Prosím dokončite kontrolu nižšie.",
    "VERIFYING": "Overujeme…",
    "ERROR": "Overenie sa nepodarilo. Skúste to prosím znova.",
    "RETRY": "Skúsiť znova"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Sme online",
    "OFFLINE": "Momentálne nie sme k dispozícii",
    "ONLINE_WITH_BOT": "Tím a náš asistent AI sú online",
    "OFFLINE_WITH_BOT": "Náš asistent AI je tu, aby pomohol",
    "BOT_ONLY_REPLY": "Odpovedá okamžite"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Zvyčajne odpovedá do niekoľkých minút",
    "IN_A_FEW_HOURS": "Zvyčajne odpovedá do niekoľkých hodín",
    "IN_A_DAY": "Zvyčajne odpovedá do dňa",
    "BACK_IN": "Opäť budeme online"
  },
  "DAY_NAMES": {
    "SUNDAY": "Nedeľa",
    "MONDAY": "Pondelok",
    "TUESDAY": "Utorok",
    "WEDNESDAY": "Streda",
    "THURSDAY": "Štvrtok",
    "FRIDAY": "Piatok",
    "SATURDAY": "Sobota"
  },
  "START_CONVERSATION": "Začať konverzáciu",
  "END_CONVERSATION": "Ukončiť konverzáciu",
  "CONTINUE_CONVERSATION": "Pokračovať v konverzácii",
  "YOU": "Vy",
  "START_NEW_CONVERSATION": "Začať novú konverzáciu",
  "RESOLVE_LATER": "Túto tému doriešime cez e-mail/telefón. Teraz sa chcem opýtať ešte na niečo iné.",
  "VIEW_UNREAD_MESSAGES": "Máte neprečítané správy",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Zobraziť nové správy",
    "CLOSE_MESSAGES_BUTTON": "Zatvoriť",
    "COMPANY_FROM": "od",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Četujte s nami"
  },
  "POWERED_BY": "Používame {brandName}",
  "EMAIL_PLACEHOLDER": "Zadajte svoj e-mail",
  "CHAT_PLACEHOLDER": "Zadajte svoju správu",
  "TODAY": "Dnes",
  "YESTERDAY": "Včera",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Celé meno",
        "PLACEHOLDER": "Prosím zadajte svoje celé meno",
        "REQUIRED_ERROR": "Vyžaduje sa celé meno"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "E-mailová adresa",
        "PLACEHOLDER": "Zadajte svoj e-mail",
        "REQUIRED_ERROR": "E-mailová adresa je povinná",
        "VALID_ERROR": "Prosím zadajte platnú e-mailovú adresu"
      },
      "PHONE_NUMBER": {
        "LABEL": "Telefónne číslo",
        "PLACEHOLDER": "Zadajte svoje telefónne číslo",
        "REQUIRED_ERROR": "Telefónne číslo je povinné",
        "DIAL_CODE_VALID_ERROR": "Vyberte kód krajiny",
        "VALID_ERROR": "Prosím zadajte platné telefónne číslo",
        "DROPDOWN_EMPTY": "Žiadne výsledky neboli nájdené",
        "DROPDOWN_SEARCH": "Vyhľadať krajinu"
      },
      "MESSAGE": {
        "LABEL": "Správa",
        "PLACEHOLDER": "Zadajte svoju správu",
        "ERROR": "Správa je príliš krátka"
      }
    },
    "CAMPAIGN_HEADER": "Pred začatím konverzácie prosím uveďte svoje meno a e-mail",
    "IS_REQUIRED": "je povinné",
    "REQUIRED": "Povinné",
    "REGEX_ERROR": "Prosím zadajte platnú hodnotu"
  },
  "FILE_SIZE_LIMIT": "Súbor prekračuje limit {MAXIMUM_FILE_UPLOAD_SIZE} pre prílohy",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Neplatné pole"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Vyhľadať emoji",
    "NOT_FOUND": "Vášmu vyhľadávaniu nezodpovedá žiadne emoji",
    "ARIA_LABEL": "Výber emoji"
  },
  "CSAT": {
    "TITLE": "Ohodnoťte konverzáciu",
    "SUBMITTED_TITLE": "Ďakujeme za odoslanie hodnotenia",
    "PLACEHOLDER": "Povedzte nám viac..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Vyžiadať prepis konverzácie",
    "SEND_EMAIL_SUCCESS": "Prepis chatu bol úspešne odoslaný",
    "SEND_EMAIL_ERROR": "Vyskytla sa chyba, skúste to prosím znova"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Populárne články",
    "VIEW_ALL_ARTICLES": "Zobraziť všetky články",
    "IFRAME_LOAD_ERROR": "Pri načítaní článku sa vyskytla chyba. Obnovte prosím stránku a skúste to znova."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Otvoriť",
      "BUY": "Kúpiť"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Obrázková správa"
    },
    "audio": {
      "CONTENT": "Hlasová správa"
    },
    "video": {
      "CONTENT": "Video správa"
    },
    "file": {
      "CONTENT": "Súbor v prílohe"
    },
    "location": {
      "CONTENT": "Lokácia"
    },
    "fallback": {
      "CONTENT": "zdieľal/a url"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Odpoveď na:"
  }
}
